<template>
  <div id="appRoot">
    <template v-if="!$route.meta.public">
      <v-app id="inspire" class="app">
        <v-form ref="form" lazy-validation>
          <app-drawer class="app--drawer"></app-drawer>
          <app-toolbar class="app--toolbar" v-bind:class="{ 'toolbar-expanded': sidebarExpanded}"></app-toolbar>
          <v-main>
            <!-- Page Header -->
            <page-header v-if="$route.meta.breadcrumb"></page-header>
            <div class="page-wrapper">
              <router-view></router-view>
            </div>
            <!-- App Footer -->
            <v-footer height="auto" class="pa-3 pt-10 app--footer">
              <span class="caption">trangkem.com design &copy; {{ new Date().getFullYear() }}</span>
              <v-spacer></v-spacer>
            </v-footer>
          </v-main>
          <!-- Go to top -->
          <app-fab></app-fab>
          <v-navigation-drawer
            class="setting-drawer"
            temporary
            right
            v-model="rightDrawer"
            hide-overlay
            fixed
          ></v-navigation-drawer>
          <v-snackbar transition="slide-x-transition" :timeout="snackbar.timeout ? snackbar.timeout : 5000" :color="snackbar.color" v-model="snackbar.show" top multi-line rounded>
            {{ snackbar.text }}
            <template v-slot:action="{ attrs }">
              <v-btn
                color="white"
                text
                v-bind="attrs"
                @click="snackbar.show = false"
              >
                X
              </v-btn>
            </template>
          </v-snackbar>
          <v-dialog v-model="delDialog" persistent max-width="320">
            <v-card>
              <v-card-title class="subheading">Xác nhận</v-card-title>
              <v-card-text><label v-html="delMessage || 'Bạn có chắc chắn muốn xóa mục đã chọn?'"></label></v-card-text>
              <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn @click="delConfirmed">Đồng ý</v-btn>
                <v-btn color="red darken-1 white--text" @click="delDialog = false">Hủy</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </v-app>
    </template>
    <template v-else>
      <transition>
        <keep-alive>
          <router-view :key="$route.fullpath"></router-view>
        </keep-alive>
      </transition>
    </template>
    <v-overlay :value="appLoading" z-index="999999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import AppDrawer from "@/components/AppDrawer";
import AppToolbar from "@/components/AppToolbar";
import AppFab from "@/components/AppFab";
import PageHeader from "@/components/PageHeader";
import AppEvents from "./event";
import { mapState } from "vuex";
import Vue from 'vue';
export default {
  components: {
    AppDrawer,
    AppToolbar,
    AppFab,
    PageHeader
  },
  data: () => ({
    confirmAction: "",
    dialogMessage: true,
    delMessage: "",
    delDialog: false,
    delId: 0,
    rightDrawer: false,
    isConfirm: false,
    snackbar: {
      show: false,
      text: "",
      color: ""
    },
    appLoading: false
  }),
  computed: {
    ...mapState({
        sidebarExpanded: state => state.commons.sidebarExpanded
    }),
    showCustomerMessage() {
      return Vue.$cookies.get('showCustomerMessage');
    }
  },
  methods: {
    delConfirmed() {
      this.delDialog = false;
      if (this.confirmAction != '') {
        this.$root.$emit('CONFIRMED_ACTION', {action: this.confirmAction, id: this.delId});
      }
      else {
        this.$root.$emit('CONFIRMED_REMOVE_DATA', this.delId);
      }
      this.delId = 0;
      this.confirmAction = "";
    }
  },
  mounted() {
    
  },
  created() {
    AppEvents.forEach(item => {
      this.$on(item.name, item.callback);
    });
    window.getApp = this;
    this.$on("APP_DRAWER_TOGGLED", () => {
      window.getApp.$store.commit("commons/setSidebarExpanded", {
        expanded: !window.getApp.sidebarExpanded
      });
    });
  }
};
</script>

<style lang="stylus" scoped>
.setting-fab {
  top: 50% !important;
  right: 0;
  border-radius: 0;
}

.page-wrapper {
  min-height: calc(100vh - 64px - 50px - 81px);
}

.toolbar-expanded {
  padding: 0 0 0 250px;
}
</style>
